/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Verify_EmailInputs */



/**
* | output |
* | --- |
* | "Please verify your email address before continuing." |
*
* @param {Login_Success_Verify_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_verify_email = /** @type {((inputs?: Login_Success_Verify_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Verify_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez vérifier votre adresse email avant de continuer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte überprüfen Sie Ihre E-Mail-Adresse, bevor Sie fortfahren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica il tuo indirizzo email prima di continuare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, подтвердите свой адрес электронной почты, прежде чем продолжить.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor verifique su dirección de correo electrónico antes de continuar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请先验证您的电子邮件地址再继续。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("続行する前にメールアドレスを確認してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आगे बढ़ने से पहले कृपया अपना ईमेल पता सत्यापित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, verifique seu endereço de e-mail antes de continuar.")
	return /** @type {LocalizedString} */ ("Please verify your email address before continuing.")
});